




































































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class BlogName extends Vue {
  get codeSnippet1 () {
    return `[HttpGet("{id}")]
[ProducesResponseType(typeof(Employer), StatusCodes.Status200OK)]
[ProducesResponseType(typeof(ProblemDetails), StatusCodes.Status404NotFound)]
public async Task<IActionResult> GetEmployer([FromRoute]int id)
{
    var employer = await DataAccessor.Employers.GetAsync(id);
    employer.Employees = await DataAccessor.Employees.GetChildrenAsync(employer.Id);
    
    return Ok(employer);
}`
  }

  get codeSnippet2 () {
    return `[HttpGet("{id}")]
[ProducesResponseType(typeof(Employer), StatusCodes.Status200OK)]
[ProducesResponseType(typeof(ProblemDetails), StatusCodes.Status404NotFound)]
public async Task<IActionResult> GetEmployer([FromRoute]int id, [FromQuery]bool hydrate = false)
{
    var employer = await DataAccessor.Employers.GetAsync(id);
    if (hydrate)
    {
        employer.Employees = await DataAccessor.Employees.GetChildrenAsync(employer.Id);
    }

    return Ok(employer);
}`
  }

  get codeSnippet3 () {
    return `namespace LanthierCodes.Employer.Models
{
    public class EmployerInfo
    {
        public string Name { get; set; }

        public string Contact { get; set; }
    }
}
`
  }

  get codeSnippet4 () {
    return `namespace LanthierCodes.Employer.Models
{
    using System.Collections.Generic;

    public class Employer : EmployerInfo
    {
        public int Id { get; set; }

        public List<Employee> Employees { get; set; } // Our "extra" data we don't always need to return
    }
}`
  }

  get codeSnippet5 () {
    return `[HttpGet("{id}")]
[ProducesResponseType(typeof(ContentItem), StatusCodes.Status200OK)]
[ProducesResponseType(typeof(ProblemDetails), StatusCodes.Status404NotFound)]
public async Task<IActionResult> GetContent(
    [FromRoute]int id, [FromQuery]bool hydrate = false)
{
    var content = await DataAccessor.Content.GetAsync(id);

    if (content == null)
    {
        return NotFound($"Content {id} not found.");
    }

    //We need these for an UPDATE operation, so populate them no matter what
    content.TagIds = (await DataAccessor.ContentTags.GetAsync(content.Id))?.Select(ct => ct.TagId); 
    content.Logo = (await DataAccessor.ContentLogos.GetChildrenAsync(content.Id))?.FirstOrDefault();

    //Anything we don't need for UPDATE can go here
    if (hydrate)
    {
        content.Files = await DataAccessor.ContentFiles.GetChildrenAsync(content.Id);
        content.Leads = await DataAccessor.Leads.GetChildrenAsync(content.Id);
        content.Tools = await DataAccessor.Tools.GetChildrenAsync(content.Id);

        //Populate even more data! Children of children of our base entity
        foreach(var file in content.Files)
        {
            file.Previews = await DataAccessor.FilePreviews.GetChildrenAsync(file.Id);
        }
    }

    return Ok(content);
}`
  }
}
